import { IMG_6toQ2EgazM58ksGSxRB1vv } from '@ecomm/contentful-media'
import { useTranslation } from '@ecomm/i18n'
import { AlarmMomentsTab } from '@ecomm/shared-components/v2/lib/AlarmMoments/AlarmMomentsTab'

export function TabDeliveries() {
  const { t } = useTranslation('alarm-moments')
  const details = [
    {
      icon: 'PersonRunning',
      text: t('detail.doorbell-motion-sensor')
    },
    {
      icon: 'PhoneRinging',
      text: t('detail.doorbell-app-notification')
    },
    {
      icon: 'Microphone',
      text: t('detail.doorbell-mic')
    },
    {
      icon: 'Video',
      text: t('detail.doorbell-police')
    },
    {
      icon: 'Video',
      text: t('detail.recording-investigation')
    }
  ] as const
  const disclaimers = [
    t('disclaimer.doorbell-motion-sensor'),
    t('disclaimer.doorbell-police'),
    t('disclaimer.recording-investigation')
  ] as const
  return (
    <AlarmMomentsTab
      image={IMG_6toQ2EgazM58ksGSxRB1vv}
      details={details}
      disclaimers={disclaimers}
    />
  )
}
